import styled from "styled-components";

const FormTitle = styled.h1`
  margin-bottom: 30px;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 2rem;
`;

export default FormTitle;
